import styled from 'styled-components';
import { ExpandableCard, colours, Title } from '@cambridgeassessment/cambridge-ui';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledExpandableCard = styled(ExpandableCard)`
display: block;
  width: 100%;
  div.MuiExpansionPanel-root {
    min-height: 32px;
  }
  .MuiAccordionDetails-root {
    display: block;
  }
  .MuiAccordionSummary-root {
    padding-bottom: 10px;
    border: none;
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledText = styled.div`
  margin: 0px;
  color: ${colours.greyishBrown};
  margin-bottom: 10px;
  font-family: SourceSansPro;
  font-size: 14px;
  padding-left: 32px;
  padding-right: 32px;
`;

export const StyledTextContainer = styled.div`
  color: ${colours.greyishBrown};
  font-family: SourceSansPro;
  font-size: 20px;
  margin-right: 10px;
`;

export const ConsortiumCentresContainer = styled.div`
  display: flex;
  font-family: SourceSansPro;
  font-size: 16px;
  flex-direction: column;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
  margin-bottom: 20px;
`;

export const ConsortiumCardSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 32px;
  padding-right: 32px;
`;

export const ConsortiumCardInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 16px;
  padding-right: 16px;
`;

export const ConsortiumCardSummary = styled.div`
  color: ${colours.greyishBrown};
  font-family: SourceSansPro;
`;

export const StyledConsortiumTitle = styled.h1`
  word-break: break-word;
  font-size: 24px;
  text-transform: capitalize;
`;
export const StyledConsortiumText = styled.span`
  word-break: break-word;
  font-size: 20px;
  text-transform: capitalize;
`;

export const StyledTitle = styled(Title)`
  word-break: break-word;
`;

export const StyledConsortiumDescription = styled.div`
  word-break: break-word;
  font-size: 16px;
  line-height: 24px;
  margin-top: 14px;
`;
